module.exports = __webpack_public_path__ + "static/media/documentIcon.330063f1.svg";